import type { ShipmentStopIdRow } from '@/utils/device-api-shipment-payload';
import type { RoutingStrategy } from '@/components/shipment/form/utils/shipment-form-routing';

export function anchorStopIdsFromRows(
  idRows: ShipmentStopIdRow[],
): { fromId: number; toId: number } | null {
  const sorted = [...idRows].sort((a, b) => a.sequence - b.sequence);
  const fromId = sorted[0]?.id;
  const toId = sorted[sorted.length - 1]?.id;
  if (fromId == null || toId == null) return null;
  return { fromId, toId };
}

export function applyRoutingStrategyToRouteSegments(
  segments: Record<string, unknown>[],
  strategy: RoutingStrategy,
  idRows: ShipmentStopIdRow[],
): Record<string, unknown>[] {
  if (strategy !== 'trackerToDestination') {
    return segments;
  }
  const anchor = anchorStopIdsFromRows(idRows);
  if (!anchor) return segments;
  return segments.map((seg) => ({
    ...seg,
    from_stop_id: anchor.fromId,
    to_stop_id: anchor.toId,
  }));
}
